import React from "react";
import { Flex, Loader } from "@mantine/core";
//
import { ContentHighlightCard } from "../components/ContentHighlightCard/index";
//
import { useColors } from "@utils/useColors";

export const AccountActivateLoading = React.memo(() => {
  const colors = useColors();

  return (
    <ContentHighlightCard>
      <Flex mih={500} color={colors.primary} align="center" justify="center">
        <Loader />
      </Flex>
    </ContentHighlightCard>
  );
});

AccountActivateLoading.displayName = "AccountActivateLoading";
